<template>
    <div class="sc02">
        <div class="sc02_map" style="background: none;">
            <div class="sc02_r">
                <p>{{ mapTitle }} 현황</p>
                <span v-if="mapDate !== ''">최종업데이트 {{ mapDate }}<br></span>
                {{ mapUnit }}
            </div>
            <div class="left_top_txt" v-if="mapText !== ''">{{ mapText }}</div>
            <Simplemap :map-scale="mapScale"
                       :gejson-url="geojsonUrl"
                       :center="mapCenter"
                       :key-prop="mapKeyProp" style="margin-top: 15px;" />
            <SimplemapMapCtrl />

            <SimplemapLegend />
        </div>
        <div class="simple_map_btn_area" v-show="selectedRealtimeTab === 'Covid'">
            <a :href="$_WC.cp + 'covid'" class="btn_covid ">코로나19 통계</a>
        </div>
    </div>
</template>

<script>
import gripUtil from "@/libs/grip.util";
import Simplemap from '@/components/Simplemap.vue';
import SimplemapMapCtrl from '@/views/main/SimplemapMapCtrl.vue';
import SimplemapLegend from "@/views/main//SimplemapLegend";
import {mapGetters} from "vuex";
import { $_WC, $_TYPE } from '@/confs/common.const';

export default {
    name: 'RealtimeSimpleMap',
    components: {
        Simplemap,
        SimplemapMapCtrl,
        SimplemapLegend,
    },
    data() {
        return {
            mapTitle: '재난안전',
            mapDate: '',
            mapText: '',
            mapUnit: '',
            mapScale: $_WC.responsiveScale === 3 ? 1 : 1.1,
        };
    },
    watch: {
        selectedRealtimeTab: {
            immediate: false,
            handler: function (newVal, oldVal) {
                switch(newVal) {
                    case 'Safety':
                        this.mapTitle = '재난안전';
                        this.mapUnit = '단위 건';
                        this.mapText = '';
                        this.setSafetyDate();
                        break;
                    case 'Accident':
                        this.mapTitle = '도로교통';
                        this.mapUnit = '단위 건';
                        this.mapText = '';
                        this.setAccidentDate();
                        break;
                    case 'Air':
                        this.mapTitle = '대기환경';
                        this.mapUnit = '';
                        this.mapText = '';
                        this.setAirDate();
                        break;
                    case 'Water':
                        this.mapTitle = '상수도';
                        this.mapUnit = '';
                        this.mapText = '';
                        this.setWaterDate();
                        break;
                    case 'Covid':
                        this.mapTitle = '코로나19';
                        this.mapUnit = '단위 명';
                        this.mapText = '서울시 홈페이지 기준';
                        this.setCovidDate();
                        break;
                }
            }
        },
        safetyList: {
            immediate: true,
            handler: function (newVal, oldVal) {
                if(this.selectedRealtimeTab === 'Safety') {
                    this.setSafetyDate();
                }
            }
        },
        accidentList: {
            immediate: true,
            handler: function (newVal, oldVal) {
                if(this.selectedRealtimeTab === 'Accident') {
                    this.setAccidentDate();
                }
            }
        },
        airSpace: {
            immediate: true,
            handler: function (newVal, oldVal) {
                if(this.selectedRealtimeTab === 'Air') {
                    this.setAirDate();
                }
            }
        },
        waterQualityList: {
            immediate: true,
            handler: function (newVal, oldVal) {
                if(this.selectedRealtimeTab === 'Water') {
                    this.setWaterDate();
                }
            }
        },
    },
    computed: {
        ...mapGetters({
            selectedRealtimeTab: 'getSelectedRealtimeTab',
            safetyList: 'getSafetyList',
            accidentList: 'getAccidentList',
            // airSpace: 'getAirSpace',
            airHjdSensorList: 'getAirHjdSensorList',
            waterQualityList: 'getWaterQualityList',
            covidSeoul: 'getCovidSeoul',
        }),
        geojsonUrl(){
            if(this.selectedRealtimeTab === 'Covid'){
                return $_WC.assets + 'geojson/adarea/11/sig.json';
            }
            return $_WC.assets + 'geojson/adarea/' + $_WC.geojsonPath + '/emd.json';
        },
        mapCenter(){
            if(this.selectedRealtimeTab === 'Covid') {
                return [126.9797916, 37.5750615];
            }
            return undefined;
        },
        mapKeyProp(){
            if(this.selectedRealtimeTab === 'Covid') {
                return 'name';
            }
            return 'adm_code';
        },
    },
    methods: {
        setSafetyDate(){
            let now = new Date();
            let basdtVal = now.format('yyyyMMdd HH:mm');
            if(this.safetyList.length > 0) {
                basdtVal = this.safetyList[0].registerTime;
            }
            this.mapDate = gripUtil.formatDate(basdtVal, 'MM.dd HH:mm');
        },
        setAccidentDate(){
            let now = new Date();
            let basdtVal = now.format('yyyyMMdd HH:mm');
            if(this.accidentList.length > 0) {
                basdtVal = this.accidentList[0].basdtVal;
            }
            this.mapDate = gripUtil.formatDate(basdtVal, 'MM.dd HH:mm');
        },
        setAirDate(){
            let now = new Date();
            let basdtVal = now.format('yyyyMMdd HH:mm');
            if(this.airHjdSensorList.length > 0) {
                basdtVal = this.airHjdSensorList[0].basdtVal;
            }
            this.mapDate = gripUtil.formatDate(basdtVal, 'MM.dd HH:mm');
        },
        setWaterDate(){
            let now = new Date();
            let basdtVal = now.format('yyyyMMdd HH:mm');
            if(this.waterQualityList.length > 0) {
                basdtVal = this.waterQualityList[0].basdtVal;
            }
            this.mapDate = gripUtil.formatDate(basdtVal, 'MM.dd HH:mm');
        },
        setCovidDate(){
            let now = new Date();
            let basdtVal = now.format('yyyyMMdd');
            if(typeof this.covidSeoul.basdtVal !== $_TYPE.UNDEF) {
                basdtVal = this.covidSeoul.basdtVal + '0000';
            }
            this.mapDate = gripUtil.formatDate(basdtVal, 'MM.dd HH:mm');
        },
    },
};
</script>
